/**
 * Shared lightweight client-side validators (CHP-809).
 *
 * These are intentionally permissive shape checks — the authoritative
 * validation is the backend (Pydantic `EmailStr`, etc.). The point is to
 * catch obvious fat-fingers BEFORE spending a rate-limited network call (or,
 * on the no-oracle forgot-password flow, before falsely telling the user a
 * link was sent), not to replicate RFC 5322.
 */

// A single `@`, a non-empty local part, and a dotted domain. Deliberately
// simple: rejects "foo", "a@b", "a@b." while accepting normal addresses.
const EMAIL_SHAPE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_SHAPE.test(value.trim());
}
